import * as api from '../api/parking';
import q from '../query';
export const parkingLotRemarksKey = (parkingLotReferenceId) => `parking-lot-remarks-${parkingLotReferenceId}`;
export const useParkingLotRemarks = (parkingLotReferenceId) => q.query(parkingLotRemarksKey(parkingLotReferenceId), () => parkingLotReferenceId
    ? api.getParkingLotRemarks(parkingLotReferenceId)
    : undefined, []);
//# sourceMappingURL=index.js.map